export default function ChatBot() {
    return (
        <div className='bg-black chatbot px-6 lg:px-0'>
            <div className="w-full lg:w-96 h-16 bg-transparent border-b-makit mx-auto rounded-full chat flex justify-center items-center">
                <p className="opacity-50 text-white">Hey Makit <span className='hand-mover '>👋🏻</span>, who are your creators?</p>
            </div>
        </div>
    )
}